import initialState, { IRecommendationState } from '../modules/recommendation/IRecommendationState';
import {
    UPDATE_RECOMMENDATION_COUNT, RESET, POPULATE_RECOMMENDATIONS, SET_SELECTED_STUDY_TEST_RECOMMENDATION,
    SET_SELECTED_RECOMMENDATION } from '../modules/recommendation/recommendation.action.const';
import { updateRecommendationCount, reset, populateRecommendations, setSelectedStudyTestRecommendation,
    setSelectedRecommendation } from '../modules/recommendation/recommendation.reducer.logic';

export function recommendationReducer(state: IRecommendationState = initialState, action) {
    switch (action.type) {
        case UPDATE_RECOMMENDATION_COUNT:
            return updateRecommendationCount(state, action);

        case RESET:
            return reset(state, action);

        case POPULATE_RECOMMENDATIONS:
            return populateRecommendations(state, action);

        case SET_SELECTED_STUDY_TEST_RECOMMENDATION:
            return setSelectedStudyTestRecommendation(state, action);

        case SET_SELECTED_RECOMMENDATION:
            return setSelectedRecommendation(state, action);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/recommendation.reducer.ts